export default __webpack_public_path__ + "img/exclamation-triangle.124c0de1.svg";